import SpecialInstructionsSetterDesktop from './SpecialInstructionsSetterDesktop';

export default SpecialInstructionsSetterDesktop;
